export default "__VITE_ASSET__VYOCaiJx__"